<template>
  <date-picker ref="datePicker" :small="true" :inputStyle="'width: 140px;'" @onChange="onChangeDate" />
</template>

<script>

  import DatePicker from "@/components/date-picker"

  export default {
    
    name: "AnticipationDateInput",

    props: ["index", "cert"],

    components: {
      DatePicker,
    },

    mounted() {
      if (this.cert.anticipationDate)
        this.$refs.datePicker.setDate(this.cert.anticipationDate)
    },

    methods: {
      onChangeDate(date) {
        this.$emit("onChangeDate", { index: this.index, date })
      },
    },
  }

</script>